import { useEffect, useState } from "react";
import { OrderTransport } from "src/app/transports/order";
import { OrderOffSiteGrid } from "src/app/types/orders/offSite";
import { TOffSiteOrderType } from "src/app/types/orders/order";

const useOrderByMoneySiteOffSiteList = (orderType: TOffSiteOrderType, moneySiteId?: number) => {
    const [orderByMoneySiteOffSiteList, setOrderByMoneySiteOffSiteList] =
        useState<Array<OrderOffSiteGrid>>();
    const [error, setError] = useState<any>();
    const [loading, setLoading] = useState(false);

    const fetch = () => {
        if (!moneySiteId || orderType === "HISTORY") return;
        setLoading(true);

        OrderTransport.listByMoneySiteOffSite(moneySiteId, orderType)
            .then((res) => {
                setOrderByMoneySiteOffSiteList(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        fetch();
    }, [moneySiteId]);

    return { orderByMoneySiteOffSiteList, loading, error, refresh };
};

export default useOrderByMoneySiteOffSiteList;
